import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {

        this.activeClass   = '-active'
        this.lastScrollPos = 0
        this.stickyHeader  = this.element
        this.headerHeight  = this.stickyHeader.offsetHeight

        this.spacerElement = document.createElement('div')
        this.spacerElement.classList.add('sticky-header-spacer')
        this.stickyHeader.before( this.spacerElement )

        this.headerOffset = this.spacerElement.offsetTop

        this.onScroll()
    }


    onScroll() {
        if ( this.lastScrollPos !== window.pageYOffset ) {
            const pastHeader = this.lastScrollPos > (this.headerOffset + this.headerHeight)

            this.spacerElement.style.height = pastHeader ? this.headerHeight + 'px' : null
            this.stickyHeader.classList.toggle( this.activeClass, pastHeader )

            if ( pastHeader ) {
                this.stickyHeader.classList.add('-was-sticky')
            }

            this.stickyHeader.classList.toggle( '-slideout', ! pastHeader )

            this.lastScrollPos = window.pageYOffset
        }

        requestAnimationFrame( this.onScroll.bind( this ) )
    }
}
